import React, { useEffect, useState } from 'react';
import * as Yup from 'yup';
import './styles.scss';
import { connect } from 'react-redux';
import { RouteComponentProps, useHistory, withRouter } from 'react-router-dom';
import {
  addToGlobalStyles,
  addToWizard,
  setGlobalStyles,
  setWizard,
} from '../../../store/actions';
import {compose} from 'redux';
import {post} from '../../../api/api';
import {uriPostConsentReceipts} from '../../../api/endpoints';
import {Column, Row} from '../../../components/layout';
import {
  AppForm,
  AppFormCheckboxField,
  AppFormSubmitButton,
} from '../../../components/forms';
import RegisterHeader from '../../../components/headers/register-header';
import Header1 from '../../../components/headers/header1';
import {functionalitiesAliasMap, strings} from '../../../util/strings';
import colors, {pageBackgrounds} from '../../../util/colors';
import * as fonts from '../../../util/fonts';
import {ITenant} from '../../../App';
import {createGUID} from '../../../util/utility';

export interface TermsUpdateProps extends RouteComponentProps {
  wizard: any;
  user: any;
  purposes: any;
  addToWizard(value: any): void;
  addToGlobalStyles(value: any): void;
  labels: typeof strings.pt.login;
  oneTrust: typeof strings.pt.oneTrust;
  availableBus: any[];
  setGlobalStyles(value: any): void;
  globalStyles: any;
  digitalCommunications: any;
  busFuncMapDefault: any;
  tenant: ITenant;
}

const validationSchema = Yup.object().shape({
  termsAccepted: Yup.boolean().required().oneOf([true]),
});

function TermsUpdate(props: TermsUpdateProps) {
  const [oneTrustIsVisible, setOneTrustIsVisible] = useState(
    props.busFuncMapDefault?.[functionalitiesAliasMap.oneTrust]
  );

  const [validForm, setValidForm] = useState(false);
  const history = useHistory();

  const [clicked, setClicked] = useState(false);

  useEffect(() => {
    if (clicked) {
      try {
        const nif = props.user.nif;
        const token = props.oneTrust.tokenMyAdv;
        const body = JSON.stringify({
          identifier: nif,
          test: true,
          requestInformation: token,
          purposes: props.purposes,
        });
        oneTrustIsVisible && post(uriPostConsentReceipts(), body);
      } catch (e: any) {}
    }
  }, [clicked]);

  useEffect(() => {
    props.addToGlobalStyles({
      background: pageBackgrounds.registerPage,
    });
  }, []);

  const termsUpdateSubmit = async () => {
    // let busWithNif: any[] = [];
    //     Object.keys(props.availableBus).forEach((el: any) => {
    //         if(props.availableBus[el].nif === props.user.nif){
    //             busWithNif.push(props.availableBus[el]);
    //         }
    // });

    // const body: any[] = [];
    // //body.push({buId: "LOG", memId: "10831766", multicode: "31362773"});

    // busWithNif.forEach((el:any) => {
    //   body.push({buId:el.buId, memId:el.memId, multicode: el.multicode});
    // })
    if (props.wizard.skipDataTreatment) {
      if (props.digitalCommunications === null) {
        history.push('/informacao-seguro');
      } else {
        history.push('/inicio');
      }
    } else {
      history.push('/tratamento-dados');
    }
  };

  return (
    <Column className="terms-update-container">
      <RegisterHeader />
      <Column className="terms-update-container">
        <Row className="terms-update-header-row">
          <Header1
            style={{...fonts.XL, color: colors.black, fontWeight: 'bold'}}
            className="terms-update">
            {props.labels?.login_updatedTerms}
          </Header1>
          <Header1
            style={{...fonts.L, color: colors.black, fontWeight: 'bold'}}
            className="terms-update-responsive">
            {props.labels?.login_updatedTerms}
          </Header1>
        </Row>
        <AppForm
          className="terms-update-form-container"
          initialValues={{
            termsAccepted: false,
          }}
          validationSchema={validationSchema}
          onSubmit={async (values) => {
            termsUpdateSubmit();
            //history.push('/tratamento-dados');
          }}
          onValidation={(valid: boolean) => {
            if (validForm !== valid) {
              setValidForm(valid);
            }
          }}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              width: '100%',
            }}>
            <div>
              <div style={{...fonts.ML}} className="terms-update-description">
                {props.labels?.login_updatedTermsDescription}
              </div>
              <div
                style={{...fonts.M}}
                className="terms-update-description-responsive">
                {props.labels?.login_updatedTermsDescription}
              </div>
              <div
                style={{
                  textAlign: 'left',
                  marginTop: 30,
                }}>
                <AppFormCheckboxField
                  purposeId={props.oneTrust.purposeTermsAndConditions}
                  style={{justifyContent: 'left', paddingTop: 30}}
                  name={'termsAccepted'}
                  label={
                    <span style={{...fonts.SM}}>
                      {props.labels?.login_acceptConditions}
                      <a
                        target="_blank"
                        href={props.labels?.login_acceptConditionsUrl}
                        style={{color: colors.blue}}
                        className="terms-update-accept-link">
                        {props.labels?.login_acceptConditionsLink}
                      </a>{' '}
                    </span>
                  }
                />
              </div>
            </div>
          </div>
          <Row className="terms-update-continue-button-wrapper">
            <AppFormSubmitButton
              disabled={!validForm}
              className="terms-update-continue-button"
              variant="primary"
              title={props.labels?.dataTreatment_continue}
              onClickFunction={() => setClicked(true)}
            />
          </Row>
        </AppForm>
      </Column>
    </Column>
  );
}

const mapStateToProps = ({
  wizard,
  user,
  purposes,
  strings,
  globalStyles,
  availableBus,
  digitalCommunications,
  busFuncMapDefault,
  tenant,
}: any) => ({
  wizard: wizard.value,
  availableBus: availableBus.value,
  user: user.value,
  purposes: purposes.value,
  labels: strings.value.pt.login,
  oneTrust: strings.value.pt.oneTrust,
  globalStyles: globalStyles.value,
  digitalCommunications: digitalCommunications.value,
  tenant: tenant.value,
  busFuncMapDefault: busFuncMapDefault.value,
});

const mapDispatchToProps = (dispatch: any) => ({
  setWizard: (value: any) => dispatch(setWizard(value)),
  addToWizard: (value: any) => dispatch(addToWizard(value)),
  addToGlobalStyles: (value: any) => dispatch(addToGlobalStyles(value)),
  setGlobalStyles: (value: any) => dispatch(setGlobalStyles(value)),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps)(withRouter(TermsUpdate))
);
